import routeUtils from 'app/shared/utils/routeUtils';
import seoUtils from 'app/shared/utils/seoUtils';
import { DEFAULT } from 'app/shared/models/Filter';

const controller = {
  getListingSeoInfo({ pathname, searchSlug }: { pathname: string; searchSlug: string }) {
    const maloneLotIdEncoded = routeUtils.getMaloneLotIdEncodedFromUrl(pathname);
    const keyword = seoUtils.translateSlugToApiKeyword(searchSlug);
    return { keyword, maloneLotIdEncoded };
  },
  getDefaultSimilarListingTypes() {
    return Object.keys(DEFAULT.rentalTypes).join(',');
  },
};

export default controller;
